(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["discount-code"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(e) {
    var btn = e.target.closest('.hauswirt-discount-code__copy-btn');
    if (!btn) return;

    var code = btn.getAttribute('data-code');
    if (!code) return;

    navigator.clipboard.writeText(code).then(function() {
      btn.classList.add('is-copied');
      setTimeout(function() {
        btn.classList.remove('is-copied');
      }, 2000);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
